import { render, staticRenderFns } from "./AdminStudentDataAnalysis.vue?vue&type=template&id=4aebeb5a&scoped=true&"
import script from "./AdminStudentDataAnalysis.vue?vue&type=script&lang=js&"
export * from "./AdminStudentDataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./AdminStudentDataAnalysis.vue?vue&type=style&index=0&id=4aebeb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aebeb5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VRow})
